import React from 'react';
import { PositionRecommendation } from '../types';
import RecommendationItem from './RecommendationItem';

interface RecommendationBatchProps {
  batchId: string;
  batchRecommendations: PositionRecommendation[];
  getRankIcon: (rank: number) => React.ReactNode;
  getRankColor: (rank: number) => string;
  getPriorityColor: (priority: string) => string;
}

const RecommendationBatch: React.FC<RecommendationBatchProps> = ({
  batchId,
  batchRecommendations,
  getRankIcon,
  getRankColor,
  getPriorityColor,
}) => {
  return (
    <div className="p-6">
      {/* Batch Header */}
      <div className="mb-4 pb-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Recommendation Batch
            </h3>
            <p className="text-sm text-gray-500">
              {batchRecommendations.length} recommendations • Generated{' '}
              {new Date(
                batchRecommendations[0]?.createdAt || '',
              ).toLocaleString()}
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-500">Batch ID</p>
            <p className="text-xs font-mono text-gray-400">{batchId}</p>
          </div>
        </div>
      </div>

      {/* Recommendations in this batch */}
      <div className="space-y-4">
        {batchRecommendations.map((recommendation) => (
          <RecommendationItem
            key={recommendation._id}
            recommendation={recommendation}
            getRankIcon={getRankIcon}
            getRankColor={getRankColor}
            getPriorityColor={getPriorityColor}
          />
        ))}
      </div>
    </div>
  );
};

export default RecommendationBatch;
